import { render } from "./DaftarTimPelaksana.vue?vue&type=template&id=60a7bd66"
import script from "./DaftarTimPelaksana.vue?vue&type=script&lang=js"
export * from "./DaftarTimPelaksana.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__